<template>
    <div class="view-qualify-index">
        <div class="classic-content-container" v-if="currentContentLayout === 'classicContent'">
            <component :is="currentStepComponent" />
        </div>
        <div class="sidebar-and-dynamic-picture-container" v-if="currentContentLayout === 'sidebarAndDynamicPicture'">
            <component :is="currentStepComponent" />
            <qualify-dynamic-picture />
        </div>
      <button
          v-if="currentStep === steps[0].slug || currentStep === steps[0].code"
          class="return-to-qualify-btn"
          aria-label="return to qualify industry"
          @click="returnToQualifyIndustry()"
      >
        <span class="icon-arrow-left is-right-side"></span>
      </button>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import QualifyDynamicPicture from "@/components/QualifyDynamicPicture/QualifyDynamicPicture.vue"

    import NeedAndApplication from "./steps/NeedAndApplication.vue"
    import Specificities from "./steps/Specificities.vue"
    import BuildingAndShelving from "./steps/BuildingAndShelving.vue"
    import WorkEnvironment from "./steps/WorkEnvironment.vue"
    import ResultsMachines from "./steps/ResultsMachines.vue"
    import TheSolutions from "./steps/TheSolutions.vue"

    export default {
        name: 'QualifyIndustryIndex',
        components:{
            QualifyDynamicPicture,
            NeedAndApplication,
            Specificities,
            BuildingAndShelving,
            WorkEnvironment,
            ResultsMachines,
            TheSolutions,
        },
        computed: {
            ...mapState({
                steps: state => state.qualifyIndustry.steps,
                currentStep: state => state.qualifyIndustry.currentStep,
                environments: state => state.qualifyIndustry.environments,
                currentEnvironment: state => state.qualifyIndustry.environment,
            }),
            currentContentLayout(){
                return this.steps.find(x => x.slug === this.currentStep || x.code === this.currentStep).contentLayout
            },
            currentStepComponent() {
                return this.steps.find(x => x.slug === this.currentStep || x.code === this.currentStep).code;
            }
        },
      methods: {
        returnToQualifyIndustry(){
          this.$buefy.dialog.confirm({
            message: this.$t('warning_leaving_qualification_all_datas_lost'),
            cancelText: this.$t('no'),
            confirmText: this.$t('yes'),
            type: 'is-success',
            onConfirm: () => {
              this.$router.push({name: 'qualify-selection'});
            }
          })
        },
      },
        watch: {
            '$route' (to) {
                // let toStep = this.steps.find(x => x.slug === to.params.step);
                // if (toStep) this.$store.commit('qualifyIndustry/setCurrentStep', toStep.code);
                // else this.$store.commit('qualifyIndustry/setCurrentStep', to.params.step);

                let routeStep = this.steps.find(step => step.code === to.params.step);
                if (routeStep && routeStep.slug)
                  this.$store.commit('qualifyIndustry/setCurrentStep', routeStep.slug);
                else this.$store.commit('qualifyIndustry/setCurrentStep', to.params.step);
            },
        },
        created(){
            if (this.$route.query.init) {
                this.$store.commit('qualifyIndustry/reset');

                let steps = [];
                // let steps = [
                //     /*{
                //         code: 'need-and-application',
                //         contentLayout: 'sidebarAndDynamicPicture',
                //         label: this.$t('need_and_application')
                //     },
                //     {
                //         code: 'the-specificities',
                //         contentLayout: 'classicContent',
                //         label: this.$t('specificities')
                //     },*/
                //     /*{
                //         code: 'work-environment',
                //         contentLayout: 'sidebarAndDynamicPicture',
                //         label: this.$t('work_environment')
                //     },*/
                //     /*{
                //         code: 'building-and-shelving',
                //         contentLayout: 'sidebarAndDynamicPicture',
                //         label: this.$t('building_and_shelving')
                //     },
                //     {
                //         code: 'building-and-shelving-outside',
                //         contentLayout: 'sidebarAndDynamicPicture',
                //         label: 'Ext : ' + this.$t('building_and_shelving')
                //     },*/
                //     /* {
                //          code: 'results-accessories',
                //          contentLayout: 'classicContent',
                //          label: this.$t('accessories')
                //      },*/
                //     {
                //         code: 'results-machines',
                //         contentLayout: 'classicContent',
                //         label: this.$t('machines')
                //     },
                //     {
                //         code: 'the-solutions',
                //         contentLayout: 'classicContent',
                //         label: this.$t('solutions')
                //     }
                // ];

                let currentEnv = this.environments.find(env => env.slug === this.currentEnvironment);
                // let currentEnv = this.environments.find(env => env.code === this.currentEnvironment);
                if (currentEnv && currentEnv.steps && currentEnv.steps.length) {
                  currentEnv.steps.forEach(step => {
                    let newStep = {
                      code: "building-and-shelving",
                      slug: "survey-" + step.slug.replaceAll('_', '-'),
                      contentLayout: "sidebarAndDynamicPicture",
                      label: step.title,
                      image: step.survey.image,
                    };

                    steps.push(newStep);
                  });
                }

                steps.push(
                    {
                      code: 'results-machines',
                      contentLayout: 'classicContent',
                      label: this.$t('machines')
                    },
                    {
                      code: 'the-solutions',
                      contentLayout: 'classicContent',
                      label: this.$t('solutions')
                    }
                );

                this.$store.commit('qualifyIndustry/setSteps', steps);
                let currentStepCode = steps[0].code;
                if (steps[0].slug) currentStepCode = steps[0].slug;

                this.$store.commit('qualifyIndustry/setCurrentStep', currentStepCode);
            }
        }
    }
</script>

<style lang="scss">
.view-qualify-index {
    .sidebar-and-dynamic-picture-container {
        margin-top: 220px;

        @media print {
            margin: 0;
        }

        @media #{$mq_phone} {
            margin-top: 0;
            padding-top: 190px;
        }
    }

    .classic-content-container {
        margin: 205px 0 150px 0;

        @media print {
            margin: 0;
            padding-top: 0 !important;
        }

        @media #{$mq_phone} {
            margin-top: 0;
            padding-top: 190px;
        }
    }

  .return-to-qualify-btn{
    position: fixed;
    bottom: 20px;
    left: 15px;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: $light-grey;
    color: $black;
    font-size: 17px;

    @media print {
      display: none;
    }
    @media #{$mq_phone} {
      position: absolute;
      bottom: -80px;
    }

    &:hover {
      background-color: $blackish;
      color: $white;
    }
  }
}
</style>
